<template>
  <div class="dependency">{{ dependency.label }}:
    <span v-if="dependency.files.length">
      <a v-for="(file, index) in dependency.files" :key="index"
        :href="file.url" target="_blank" download>{{ file.name }}</a>
    </span>
    <span v-else><strong>{{ dependency.value }}</strong></span>
  </div>
</template>
<script>
  export default {
    name: 'review-dependency-component',
    props: {
      dependency: {
        type: Object,
        required: true
      }
    }
  }
</script>
<style lang="sass" scoped>
  .dependency
    padding: 1rem 0 0 0
</style>
